import CourseListBody from "../../components/Course/CourseListBody";
import Page from "../../finwell/pages/Page";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCoursesListing,
  getCoursesListingClear,
  getCoursesListingClearFromBroker,
  getCoursesListingClearFromWoo,
  getCoursesListingFromBroker,
  getCoursesListingFromWoo,
  getModuleListingClear,
  getModuleListingClearBroker,
  getProductCategories,
} from "../../redux/courses/actions";
import _ from "lodash";
import {
  convertHoursToMins,
  convertTimeFormat,
  getFormatCourseListFromWoo,
  SessionKeys,
} from "../../utils/AppUtils";
import ShimmerScreen from "../../components/Layouts/ShimmerScreen";
import ShimmerCardBody from "../../components/Layouts/ShimmerCardBody";
import CourseListingSection from "../../components/Course/CourseListingSection";


const CourseListingPage = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      <Page>
        <CourseListingSection
        isLoading={isLoading}
        setIsLoading={setIsLoading}/>
      </Page>
    </>
  );
};
export default CourseListingPage;
